//import "./polyfills";
import { BrowserRouter } from "react-router-dom";
import Pagina from "./Pagina";
import ErrorBoundary from "./components/ErrorBoundary";
import { StrictMode } from 'react';
const App = () => (
    <StrictMode>
        <ErrorBoundary>
            <BrowserRouter>
                <Pagina />
            </BrowserRouter>
        </ErrorBoundary>
    </StrictMode>
);
export default App;
